export const initialUser = {
    id: 0,
    firstName: 'Default',
    lastName: 'Default',
    primaryEmail: 'Default',
    userId: 'Default',
    userName: 'Default',
};
